export default __webpack_public_path__ + "static/media/Manufacturer name 3.da551b2c.png";